import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';

interface EmploymentTypeSectionProps {
  employmentType: string;
}

export const EmploymentTypeSection: React.FC<EmploymentTypeSectionProps> = ({
  employmentType,
}) => {
  return (
    <div className="space-y-3 opacity-50">
      <div className="flex items-center gap-2">
        <Label className="text-base">Default Employment Type</Label>
        <span className="text-xs bg-muted text-muted-foreground px-2 py-0.5 rounded">Coming Soon</span>
      </div>
      <RadioGroup 
        value={employmentType} 
        onValueChange={() => {}}
        className="flex flex-col space-y-2 pointer-events-none md:space-y-3"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="1099" id="1099" disabled />
          <Label htmlFor="1099" className="text-muted-foreground">1099 (Contractor)</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="W2" id="W2" disabled />
          <Label htmlFor="W2" className="text-muted-foreground">W2 (Employee)</Label>
        </div>
      </RadioGroup>
    </div>
  );
};
